import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Center,
  Select,
  Pagination,
  Checkbox,
  Tabs,
  Badge,
} from "@mantine/core";
import {
  IconSearch,
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconTrash,
  IconChecklist,
  IconUserPlus,
  IconEye,
  IconTruck,
} from "@tabler/icons-react";
import classes from "./Corporate.module.css";
// import DeleteStaff from "./DeleteStaff";
import { RowDataCorporate } from "./types";
import { props } from "./props";
import { CustomTable } from "../Table/CustomTable";
import { corporate } from "../types/RowDataTypes";
import { useFetchRowData } from "../hooks/useFetchRowData";
import { SearchBar } from "../SearchBar/SearchBar";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import { useLocation, useNavigate } from "react-router-dom";
import {
  showErrorAlert,
  showEditWarning,
  showSuccessAlert,
} from "../../helper/alerts";
import Header from "../static/Header";
import VerifyCorporate from "./VerifyCorporate";
// import getOrderTable from "../../DataDisplay/DataDisplayTable/OrderTable";
import getCorporateTable from "../../DataDisplay/DataDisplayTable/CorporateTable";

import { formatDD_MM_YYYY } from "../../helper/DateTime";

enum ColumnHeaderToFilterPair {
  FULLNAME = "Name",
//   UID = "UID",
    CONTACTNO = "Contact No",
//   EMAIL = "Email",
  CREATEDAT = "Registered At",
  COMPANY = "Company",
//   TYPE = "Type",
}

const colFilter = ColumnHeaderToFilterPair;
const colFilters: { [key in ColumnHeaderToFilterPair]: string } = {
  [colFilter.FULLNAME]: "fullname",
//   [colFilter.UID]: "uid",
  [colFilter.CONTACTNO]: "phone_number",
//   [colFilter.EMAIL]: "email",
  [colFilter.CREATEDAT]: "createdAt",
  [colFilter.COMPANY]: "company",
//   [colFilter.TYPE]: "",
};

function Th({ children, sortable, reversed, sorted, onSort }: props) {
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  let allowedSorts;

  allowedSorts = [
    // colFilter.COMPANY.toString().toLowerCase(),
    colFilter.FULLNAME.toString().toLowerCase(),
    colFilter.CREATEDAT.toString().toLowerCase(),
    // colFilter.CONTACTNO.toString().toLowerCase(),
    // colFilter.EMAIL.toString().toLowerCase(),
    // colFilter.DOB.toString().toLowerCase(),
];
  const isCurrent =
    window.location.href.split("/")[5] === "unverified" ? true : false;
//   console.log("the children");
//   console.log(children);
//   console.log(allowedSorts);
//   console.log(allowedSorts.includes(children!!.toString().toLowerCase()));

  return children!! === "action" && !isCurrent ? (
    <></>
  ) : (
    <Table.Th className={`${classes.th} ${sortable ? classes.sortable : ""}`}>
      {allowedSorts.includes(children!!.toString().toLowerCase()) ? (
        <UnstyledButton onClick={onSort} className={classes.control}>
          <div className={classes.sortableHeader}>
            <Text fw={500} fz="sm">
              {children}
            </Text>
            <Center className={classes.icon}>
              <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </Center>
          </div>
        </UnstyledButton>
      ) : (
        <Text fw={500} fz="sm">
          {children}
        </Text>
      )}
    </Table.Th>
  );
}

const initialData: RowDataCorporate[] = [
  {
    uid: "",
    fullname: "",
    phone_number: "",
    email: "",
    dob: "",
    company: "",
    corporate_card:"",
    action: "",
    nric_fullname: "",
    nric: "",
    tin: "",
    address_line_1: "",
    address_line_2: "",
    postal: "",
    city: "",
    state: "",
    country: "",
    business_phone_number: "",
    sst_registration_number: "",
    nricImg: "",
    isVerified: false,
    createdAt: "",
    ssm_number: "",
    msic: "",
    submittedAt: "",
  },
];

export function Corporate() {
  const axiosPrivate = useAxiosPrivate();

  const [search, setSearch] = useState<string>("");
  const [sortedData, setSortedData] = useState(initialData);
  const [sortBy, setSortBy] = useState<keyof RowDataCorporate | null>(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [tableStateChanged, setTableStateChanged] = useState(0);
  const changeTableState = () => {
    setTableStateChanged(Math.random() * Math.random());
  };

  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const resetPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
      return true;
    }
    return false;
  };

  const checkboxesFilter: JSX.Element[] = [];

  //Set allowed search filter checkbox to be shown
  const allowedFilters = [
    // colFilters[colFilter.UID],
    colFilters[colFilter.FULLNAME],
    colFilters[colFilter.CONTACTNO],
    // colFilters[colFilter.EMAIL],
    colFilters[colFilter.COMPANY],
  ];

  for (const [key, value] of Object.entries(colFilters)) {
    if (allowedFilters.includes(value)) {
      const checkboxFilter: JSX.Element = (
        <Checkbox value={value} label={key} />
      );
      checkboxesFilter.push(checkboxFilter);
    }
  }

  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setSearch(input);
  };

  const location = useLocation();
  const fetchedData = useFetchRowData(
    itemsPerPage,
    currentPage,
    search,
    selectedFilters,
    tableStateChanged,
    sortBy ?? "createdAt",
    reverseSortDirection ? "DESC" : "ASC",
    corporate,
    getCorporateTable().create(),
    {
      current: location.pathname.split("/")[2] ?? "verified",
    //   current: "unverified",
    },
  );

  const itemsOnPage = useRef(0);
  const totalRows = fetchedData.totalRows;
  const rowData: RowDataCorporate[] | null = fetchedData.data as RowDataCorporate[];
  const isLoading: boolean = fetchedData.isLoading;
  const [RowDataDealer, setRowDataDealer] = useState<RowDataCorporate[] | null>(null);

  useEffect(() => {
    setRowDataDealer(rowData);
    itemsOnPage.current = fetchedData.itemsOnPage;
  }, [rowData]);

  const [selectedRow, setSelectedRow] = useState<RowDataCorporate | null>(null);
  const [isEditMode, setEditMode] = useState(false);
  const handleEdit = (row: RowDataCorporate) => {
    setSelectedRow(row);

    // Check if the current page is "pass", then show the edit warning
    if (location.pathname.split("/")[2] === "verified") {
      showEditWarning("Are you sure you want to edit this corporate?", setEditMode);
    } else {
      // If the page is not "pass", directly setEditMode to true
      setEditMode(true);
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handleVerifyCorporate = (
    editedData: RowDataCorporate,
    originalData: RowDataCorporate | null,
    action: string,
    remark: string,
  ) => {
    if (originalData) {
      const paramsToUpdate = {
        uid: originalData.uid,
        action: action,
        remark: remark,
      };

      axiosPrivate
        .post("/api/admin/corporate/verify-corporate", paramsToUpdate)
        .then((response) => {
          if (
            itemsOnPage.current == 1 &&
            currentPage !== 1 &&
            currentPage == Math.ceil(totalRows / itemsPerPage)
          )
            setCurrentPage((prev) => prev - 1);
          else changeTableState();
          showSuccessAlert("Corporate Successfully Updated");
        })
        .catch((error) => {
          showErrorAlert("An error has occured");
        });
    }

    setEditMode(false);
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (value: number) => {
    setCurrentPage(1);
    setItemsPerPage(value);
  };

  const isCurrent =
    location.pathname.split("/")[2] === "verified" ? true : false;
  const rowsToMap = RowDataDealer ?? [];
  const rows = rowsToMap.map((row, index) => (
    <Table.Tr key={index}>
      <Table.Td>{startIndex + index + 1}</Table.Td>
      <Table.Td>{row.fullname}</Table.Td>
      {/* <Table.Td style={{ width: "5%" }}>{row.uid}</Table.Td> */}
      <Table.Td>+60 {row.phone_number}</Table.Td>
      {/* <Table.Td>{row.email}</Table.Td> */}
      <Table.Td>{formatDD_MM_YYYY(row.createdAt)}</Table.Td>
      <Table.Td>{row.company ? row.company : '-'}</Table.Td>
      {/* <Table.Td>{row.company ? <Badge variant="outline" color="blue">Company</Badge> : <Badge variant="outline" color="teal">Individual</Badge>}</Table.Td> */}
      <Table.Td className={classes.actionButtons}>
        {row.nric && !row.isVerified ?
            <button onClick={() => handleEdit(row)} className={classes.editbutton}>
                <IconChecklist /> Verify Corporate
            </button>
        : !row.nric && !row.isVerified ?
            null
        : 
            null
        }
        
      </Table.Td>
    </Table.Tr>
  ));

  const handleSelectPage = (selectedPage: number) => {
    if (selectedPage != currentPage) setCurrentPage(selectedPage);
  };

  const nav = useNavigate();

  const handleTabChange = (val: string | null) => {
    val = val ?? "verified";
    nav(`/corporate/${val}`);
    changeTableState();
  };

  const handleSorting = (val: any) => {
    setReverseSortDirection(!reverseSortDirection);
    setSortBy(val);
    changeTableState();
    // console.log("sorting");
    // console.log(val);
    // console.log(reverseSortDirection);
  };

  return (
    <div className={classes.orderContainer}>
      <ScrollArea className={classes.parentContainer}>
        <Header
          title={
            <div>
              <p>Corporate</p>
            </div>
          }
        />

        <div className={classes.searchBarContainer}>
          <SearchBar
            isLoading={isLoading}
            resetPage={resetPage}
            changeTableState={changeTableState}
            search={search}
            handleSearch={handleSearch}
            setShowFilterOptions={setShowFilterOptions}
            showFilterOptions={showFilterOptions}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            checkboxesFilter={checkboxesFilter}
          />
        </div>


        <Tabs
          defaultValue="verified"
          color="blueviolet"
          variant="pills"
          onChange={(value) => {
            handleTabChange(value);
          }}
        >
            <Tabs.List className={classes.tabHeader}>
                <Tabs.Tab value="verified" className={classes.tabTitle}>
                    Verified
                </Tabs.Tab>
                <Tabs.Tab value="pending-verification" className={classes.tabTitle}>
                    Pending Verification
                </Tabs.Tab>
                <Tabs.Tab value="unverified" className={classes.tabTitle}>
                    Unverified
                </Tabs.Tab>
            </Tabs.List>
          <ScrollArea
            // w={
            //   window.innerWidth -
            //   document.getElementById("nav-bar")!!.getBoundingClientRect().width
            // }
          >
            <Tabs.Panel value="pending-verification">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="unverified">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="verified">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>
          </ScrollArea>

        </Tabs>

        <div className={classes.footerContainer}>
          <div className={classes.resultCount}>
            <Text>
              {`Showing `}
              <span style={{ fontWeight: "bold" }}>{startIndex + 1}</span>
              {`-`}
              <span style={{ fontWeight: "bold" }}>
                {Math.min(currentPage * itemsPerPage, totalRows)}
              </span>
              {` of `}
              <span style={{ fontWeight: "bold" }}>{totalRows}</span>
              {` results `}
            </Text>
          </div>

          <div className={classes.rightContainer}>
            <div className={classes.rowsPerPageSelector}>
              <Select
                placeholder="Rows per page"
                data={["10", "20", "50"]}
                value={itemsPerPage.toString()}
                onChange={(value) =>
                  handleRowsPerPageChange(parseInt(value as string, 10))
                }
              />
            </div>

            <div className={classes.paginationSelector}>
              <Pagination
                color="blueviolet"
                value={currentPage}
                total={Math.ceil(totalRows / itemsPerPage)}
                onNextPage={() => handlePageChange(currentPage + 1)}
                onPreviousPage={() => handlePageChange(currentPage - 1)}
                onChange={(value: number) => handleSelectPage(value)}
              />
            </div>
          </div>
        </div>

        {isEditMode && (
          <VerifyCorporate
            isOpen={isEditMode}
            onClose={() => setEditMode(false)}
            onSaveChanges={(editedData, action, remark) =>
                handleVerifyCorporate(editedData, selectedRow, action, remark)
            }
            initialData={selectedRow as RowDataCorporate}
          />
        )}
      </ScrollArea>
    </div>
  );
}

export default Corporate;
